export default __webpack_public_path__ + "static/media/blank.bee7ab5e.png";